export interface Header {
    height: number;
}

const header: Header = {
    height: 5,
};

export default header;
